import React from 'react';
import {styled} from '@netx/core-components/Theme';
import {type ICategory} from '../../schema';
import {CategoryCard} from '../CategoryCard';

const CategoryCardsRoot = styled('div', {
	name: 'CategoryCards',
	slot: 'Root',
})(({theme}) => ({
	display: 'grid',
	gridAutoRows: 243,
	gridColumnGap: 16,
	gridRowGap: 16,
	padding: theme.spacing(1, 2),
	// [theme.breakpoints.up('md')]: {
	// 	gridTemplateColumns: 'repeat(3, 1fr)',
	// },
	// [theme.breakpoints.up('lg')]: {
	// 	gridTemplateColumns: 'repeat(4, 1fr)',
	// },
	// [theme.breakpoints.up('xl')]: {
	// 	gridTemplateColumns: 'repeat(5, 1fr)',
	// },
	[theme.breakpoints.up('sm')]: {
		gridTemplateColumns: 'repeat(2, 1fr)',
		gridAutoRows: 243,
	},
	...new Array(10).fill(null).reduce(
		(acc, _, index) => ({
			...acc,
			[theme.breakpoints.up(700 + index * 345)]: {
				gridTemplateColumns: `repeat(${index + 2}, 1fr)`,
			},
		}),
		{},
	),

	[theme.breakpoints.down('sm')]: {
		gridTemplateColumns: 'repeat(1, 1fr)',
		padding: theme.spacing(0, 2, 2, 2),
		// gridAutoRows: 280,
	},
}));

export interface CategoryCardsProps {
	categories?: ICategory[];
	displayDescription?: boolean;
	loading?: boolean;
}

export const CategoryCards = ({
	categories,
	displayDescription,
	loading,
}: CategoryCardsProps) => {
	const arr = new Array(loading ? 9 : categories?.length || 0).fill(null);
	return (
		<CategoryCardsRoot data-testid="category-cards">
			{arr.map((_, index) => {
				const category = categories?.[index];
				return (
					<CategoryCard
						key={category ? category.id : `loading-${index}`}
						category={category}
						displayDescription={displayDescription}
					/>
				);
			})}
		</CategoryCardsRoot>
	);
};

export default CategoryCards;
